import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Close from '../assets/Close'; 

import './Modal.css';

class Modal extends Component {
    render() {
        const { open, children, onClose } = this.props;
        if (open) {
            document.documentElement.style.overflow = 'hidden';
            document.body.scroll = "no";
        } else {
            document.documentElement.style.overflow = 'scroll';
            document.body.scroll = "yes";
        }
        return (
            open ?
            ReactDOM.createPortal(
                <div className="modal-overlay">
                    <div className="modal">
                        <span className="close" onClick={onClose}><Close fill="#DDDDDD"/></span>
                        {children}
                    </div>
                </div>,
                document.body,
            ) : null
        );
    }
};

export default Modal;


// WEBPACK FOOTER //
// ./src/Components/Modal/Modal.js